import React from 'react';
import { ContractVersionSetting, TitleContentLayout } from '@zen/common-app-parts';
import { useVersionsSetting } from './settingsHooks';

const VersionsSetting = () => {
  return (
    <TitleContentLayout dark title="Contract Versions Settings">
      <ContractVersionSetting useContract={useVersionsSetting} />
    </TitleContentLayout>
  );
};

export default VersionsSetting;
